module.exports = __webpack_public_path__ + "media/images/pdf-file-icon-33b53fb462bb543bf1bbef02cb5c0d27.svg";